// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8c7f5c60","513":"eb9ca4c5","703":"674d2745","787":"cda612ba"}[chunkId] + ".chunk.js";
};